import {
    ContextMenuData,
    actionContextMenu,
    ACTIVATE_SIDE_CONTEXTMENU,
    CLOSE_SIDE_CONTEXTMENU,
} from '../../Actions/Atlas/contextSideMenu.action';
import { RESET_ALL } from '../../Actions/globals.actions';

const defaultContextMenuData: ContextMenuData = {
    id: '0',
    x: 0,
    y: 0,
    active: false,
};

export default (state: ContextMenuData = defaultContextMenuData, action: actionContextMenu) => {
    switch (action.type) {
        case ACTIVATE_SIDE_CONTEXTMENU: {
            return action.payload;
        }
        case CLOSE_SIDE_CONTEXTMENU: {
            return defaultContextMenuData;
        }
        case RESET_ALL: {
            return defaultContextMenuData;
        }
        default:
            return state;
    }
};
